import { useEffect, useState } from 'react';
import { UpdateChatbotStateOptions } from '../endion-chatbot';
import { ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME } from '../utils/events';

/**
 * Hook to manage chatbot trigger visibility state with external control support
 * Listens for external events to control the trigger visibility via window.endion.updateChatbotState()
 */
export function useChatbotTriggerState(initialShowTrigger = true) {
  const [showTrigger, setShowTrigger] = useState(initialShowTrigger);

  // Listen for external chatbot trigger state changes
  useEffect(() => {
    const handleToggleState = (event: Event) => {
      const customEvent = event as CustomEvent<UpdateChatbotStateOptions>;
      const { showTrigger: externalShowTrigger } = customEvent.detail;

      if (typeof externalShowTrigger === 'boolean') {
        setShowTrigger(externalShowTrigger);
      }
    };

    document.addEventListener(ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME, handleToggleState);

    return () => {
      document.removeEventListener(ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME, handleToggleState);
    };
  }, []);

  return {
    showTrigger,
    setShowTrigger,
  };
}
